import {
  Flex,
  mdBumps,
  Section,
  SectionContent,
  SectionDescription,
  SectionProps,
  SectionTitle,
} from '@wrisk/ui-components'
import React, { FunctionComponent, useMemo } from 'react'

import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { useProposal } from '../../../product/proposal/ProposalProvider'
import { PaymentFrequency, shouldRenderPaymentFrequency } from './PaymentFrequency'

const tKey = TKey('components.proposal-configuration-section')

export const ProposalConfigurationSection: FunctionComponent<SectionProps> = (props) => {
  const { t } = useWriskTranslation()
  const { proposal } = useProposal()

  const shouldRender = useMemo(() => shouldRenderPaymentFrequency(proposal), [proposal])

  if (!shouldRender) return null

  const subheader = t(tKey('subheader'), { defaultValue: null })

  return (
    <Section width={1} {...props}>
      <SectionTitle>{t(tKey('header'))}</SectionTitle>
      {subheader && <SectionDescription>{subheader}</SectionDescription>}
      <SectionContent>
        <Flex flexDirection='column' variant='raised' p={mdBumps}>
          <PaymentFrequency tKey={tKey} />
        </Flex>
      </SectionContent>
    </Section>
  )
}
